export default "__VITE_ASSET__BlD791Q0__"